module.exports = __webpack_public_path__ + "static/turtle_ao-2798637b32c9f07765c791e30d077837.png";